module.exports = __webpack_public_path__ + "img/database.c9434951.svg";